import { Skeleton, Stack, Typography } from '@mui/material';
import { Component } from 'react';
import { MdTrendingDown } from 'react-icons/md';

export default class ApuracaoPanel2 extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { loading, dados } = this.props;
        return (
            <>
                {loading ? <Skeleton height={182} variant="rounded" /> :
                    <Stack bgcolor="#fef2f2" color="#b91c1c" borderRadius={2} border="1px solid #e5e7eb" p={2} gap={1} flex={1}>
                        <Stack direction="row" justifyItems="center" gap={1}>
                            <MdTrendingDown size={12} />
                            <Typography fontSize={10}><b>NOTAS FISCAIS - PERDA / BAIXA</b></Typography>
                        </Stack>
                        <Typography fontSize={18}><b>{dados?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})}</b></Typography>
                    </Stack>
                }
            </>
        );
    }
}